import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Product {
  id: string;
  name: string;
  price_cents: number;
  original_price_cents: number | null;
  discount_label: string | null;
  features: string[];
  bonus_text: string | null;
  is_active: boolean;
}

export const useProducts = () => {
  const [products, setProducts] = useState<Record<string, Product>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data, error: fetchError } = await supabase
          .from('products')
          .select('*')
          .eq('is_active', true);
        
        if (fetchError) throw fetchError;
        
        if (data) {
          const productMap = data.reduce((acc, p) => {
            const features = Array.isArray(p.features) 
              ? (p.features as unknown as string[]) 
              : [];
            acc[p.id] = {
              ...p,
              features,
            };
            return acc;
          }, {} as Record<string, Product>);
          setProducts(productMap);
        }
      } catch (err: any) {
        console.error('Error fetching products:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchProducts();
  }, []);

  // Helper to format cents to BRL display
  const formatPrice = (cents: number) => {
    return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  };

  return { products, loading, error, formatPrice };
};
